'use strict';

const {getIn, has} = require('@zerolight/mapping-helpers');
const _ = require('lodash');
const $ = require('jquery');
const rearg = require('./rearg');

const {CSSList} = require('./css-list');
const {formatDate, formatNumber, formatMinutes, pretty} = require('./formatters');


function noop() {
}

function identity(v) {
	return v;
}

function isContainer($container) {
	return $container instanceof $ || _.isElement($container) || _.isString($container);
}

function cssClasses() {
	let c = new CSSList();
	for (let a of arguments) {
		c.add(a);
	}
	return c.css;
}


function bindHandler(context, handler) {
	return function () {
		return handler.call(context, this, ... arguments);
	}
}

function bindHandlers(context, ... names) {
	for (let name of names) {
		let handler = context[name];
		if (!_.isFunction(handler)) {
			throw new TypeError(`${name} should be a function`);
		}
		context[name] = bindHandler(context, handler);
	}
}

function bindCallback(method, context, ... bargs) {
	return function wrapper(... args) {
		let callback;
		let l = args.length;
		if (l && _.isFunction(args[l - 1])) {
			callback = args[l - 1];
			// args = args.slice(0, -1);
		}
		// If it returns promise...
		let returns = method.call(context, ...bargs, ...args);
		if (returns instanceof Promise) {
			if (callback) {
				// If callback is given - handle it and return nothing
				returns
					.then(
						function (result) {
							callback(null, result);
						},
						function (reason) {
							callback(reason);
						}
					)
					.catch(function (err) {
						console.error(err);
					});
				return;
			}
		}
		return returns;
	}
}

function bindCallbackAll(obj, ... methods) {
	for (let key of methods) {
		let method = obj[key];
		if (_.isFunction(method)) {
			obj[key] = bindCallback(method, obj);
		}
	}
}

function thenCallback(promise, callback) {
	if (callback) {
		promise
			.then(
				function (response) {
					callback(null, response);
				},
				function (err) {
					callback(err);
				}
			)
			.catch(function (err) {
				console.error(err);
				throw err;
			});
	} else {
		return promise;
	}
}

const DOES_IT_LOOK_LIKE_REGEXP = /^\/(.+)\/([im]+)?$/;
function testString(test, string) {
	let m;
	if (test instanceof RegExp) {
		return test.test(string);
	}
	if ((m = DOES_IT_LOOK_LIKE_REGEXP.test(test))) {
		test = new RegExp(m[1], m[2]);
		return test.test(string);
	}
	return test === string;
}

let _uniqueIdCounter = 0;

function uniqueId() {
	_uniqueIdCounter = (_uniqueIdCounter + 1) & 0xff;
	return (
		_uniqueIdCounter.toString(16).padStart(2, '0') +
		((Math.random() * 0xffff) & 0xffff).toString(16).padStart(4, '0')
	);
}

function wait(to, resolveWith) {
	return new Promise((res) => {
		setTimeout(res, to, resolveWith);
	});
}

function getFieldName(field) {
	return Array.isArray(field) ? field[0] : field;
}

function getFieldTitle(field) {
	let title;
	if (Array.isArray(field)) {
		title = field[1];
	}
	return title || pretty(getFieldName(field));
}


module.exports = {
	noop, identity,
	rearg, cssClasses, isContainer,
	bindHandler, bindHandlers, bindCallback, bindCallbackAll, thenCallback, testString,
	uniqueId, wait, getIn, has,
	getFieldName, getFieldTitle,
	formatDate, formatNumber, formatMinutes, pretty
};